import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { ProductReveal } from './components/ProductReveal';
import { Tomos } from './components/Tomos';
import { Checklist } from './components/Checklist';
import { Testimonials } from './components/Testimonials';
import { Bonos } from './components/Bonos';
import { Purchase } from './components/Purchase';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans selection:bg-brand-teal selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Problem data-id="element-3" />
        <ProductReveal data-id="element-4" />
        <Tomos data-id="element-5" />
        <Checklist data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Bonos data-id="element-8" />
        <Purchase data-id="element-9" />
        <Guarantee data-id="element-10" />
        <FAQ data-id="element-11" />
      </main>
      <Footer data-id="element-12" />

      <PurchasePopup data-id="element-13" />
      <StickyCTA data-id="element-14" />
    </div>;
}